import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AIAgents from "../pages/ai-agents/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsOfUse from "../pages/terms-of-use/page";
import Blog from "../pages/blog/page";
import UnderstandingForm1040 from "../pages/blog/understanding-form-1040/page";
import BusinessTaxFormsGuide from "../pages/blog/business-tax-forms-guide/page";
import StateTaxCompliance from "../pages/blog/state-tax-compliance/page";
import DemoVideo from "../pages/demo-video/page";
import Partnerships from "../pages/partnerships/page";
import HimalayaPartnership from "../pages/himalaya-partnership/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/ai-agents",
    element: <AIAgents />,
  },
  {
    path: "/demo-video",
    element: <DemoVideo />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/understanding-form-1040",
    element: <UnderstandingForm1040 />,
  },
  {
    path: "/blog/business-tax-forms-guide",
    element: <BusinessTaxFormsGuide />,
  },
  {
    path: "/blog/state-tax-compliance",
    element: <StateTaxCompliance />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-use",
    element: <TermsOfUse />,
  },
  {
    path: "/partnerships",
    element: <Partnerships />,
  },
  {
    path: "/himalaya-partnership",
    element: <HimalayaPartnership />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
